// extracted by mini-css-extract-plugin
export default {"createNewButtonV2":"create-new-button-v2_createNewButtonV2__tkEdo","buttonText":"create-new-button-v2_buttonText__9Zotr"};